import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrency,
  getMasterCurrency,
} from "../../../../Redux/action/MasterAction";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../../Config";
import { BeatLoader } from "react-spinners";
import AccountPagination from "../../../Masters/AccountMaster/GroupMaster/AccountPagination";

const CurrencyCreateForm = () => {
  const token = Cookies.get("token");
  let user_id = Cookies.get("flexichain_user_id");
  let currencyData = useSelector((state) =>
    state?.MasterReducer ? state?.MasterReducer?.currencyData : [],
  );
  const {
    loadingMasterCurrency,
    MasterCurrency,
    MasterCurrencyError,
    MasterCurrencyCurrentPage,
    MasterCurrencyTotalPage,
    MasterCurrencyTotalData,
  } = useSelector((state) => state?.MasterReducer);

  // const [dataSourcer, setDataSourcer] = useState([
  //   {
  //     key: 1,
  //     code: "USD",
  //     name: "US Dollar",
  //     symbol: "$",
  //     exchange_rate: "83.20",
  //     base_currency: "NO",
  //     action: "View History",
  //   },
  //   {
  //     key: 2,
  //     code: "EUR",
  //     name: "Euro",
  //     symbol: "€",
  //     exchange_rate: "89.50",
  //     base_currency: "NO",
  //     action: "View History",
  //   },
  //   {
  //     key: 3,
  //     code: "INR",
  //     name: "Indian Rupee",
  //     symbol: "₹",
  //     exchange_rate: "1",
  //     base_currency: "YES",
  //     action: "View History",
  //   },
  // ]);

  const [groupFormData, setGroupFormData] = useState({
    currency_code: "",
    currency_name: "",
    currency_symbol: "",
    exchange_rate: "",
    base_exchange_rate: "",
    rate_date: "",
    rate_source: "",
    decimal_places: "",
    base_currency: "",
    auto_update: "",
  });

  // console.log("MasterCurrency", MasterCurrency);
  const [reload, setReload] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [MasterName, setMasterName] = useState(null);
  const [MasterID, setMasterID] = useState(null);
  // const handleAddShow = () => setAddShow(true);

  const navigate = useNavigate();
  const location = useLocation();

  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const dispatch = useDispatch();

  const handleCurrencyChange = (e) => {
    const selectedCode = e.target.value;

    const selectedCurrency = currencyData.find(
      (item) => item.currency === selectedCode,
    );

    if (selectedCurrency) {
      setGroupFormData((prev) => ({
        ...prev,
        currency_code: selectedCurrency.currency,
        currency_name: selectedCurrency.currency_name,
        currency_symbol: selectedCurrency.currency_symbol,
      }));
    }
  };

  const nonNegativeFields = ["exchange_rate", "base_exchange_rate"];

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;

    // if(name === "exchange_rate" || name === "base_exchange_rate"){
    //   // const numericValue = value === "" ? "" : parseFloat(value);
    //   if (value < 0) {
    //     return alert("Negative value not allowed");
    //   }
    //   // setGroupFormData((pre) => ({
    //   //   ...pre,
    //   //   [name]: value,
    //   // }));
    //   return;
    // }

    let finalValue = value;
    // If input type is number
    if (type === "number") {
      const numericValue = Number(value);

      // Block negative values for fixed fields
      if (nonNegativeFields.includes(name) && numericValue < 0) {
        finalValue = ""; // or "" if you prefer empty
      } else {
        finalValue = numericValue;
      }
    }

    setGroupFormData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : finalValue,
    }));
  };

  const submitGroupForm = async () => {
    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/currency-master`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
            user_id: Cookies.get("flexichain_user_id"),
          },
          body: JSON.stringify(groupFormData),
        },
      );
      const data = await response.json();

      if (response.ok) {
        // closeButtonRef.current.click();
        // if (onSuccess) onSuccess();
        toast.success(data?.msg);
        refresh();
        clearGroupForm();
      } else {
        toast.error(data?.msg);
        // Handle errors from the server
        console.error("Error creating master currency:", data.message);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const clearGroupForm = () => {
    setGroupFormData({
      currency_code: "",
      currency_name: "",
      currency_symbol: "",
      exchange_rate: "",
      base_exchange_rate: "",
      rate_date: "",
      rate_source: "",
      decimal_places: "",
      base_currency: false,
      auto_update: false,
    });
  };

  const refresh = () => {
    if (token && user_id) {
      dispatch(
        getMasterCurrency(
          token,
          user_id,
          queryParams.get("page") ?? 1,
          queryParams.get("search"),
        ),
      );
    }
  };

  const statusChange = async (id) => {
    setSpinnerLoader(true);
    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/currency-master-status`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ id: id.toString() }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        refresh();
        setSpinnerLoader(false);
        // handleSuccess(); // Call the success handler
        toast.success(data?.msg);
      } else {
        setSpinnerLoader(false);
        toast.error(data?.msg);
      }
    } catch (error) {
      setSpinnerLoader(false);
      console.error("Network error:", error);
    }
  };

  const handleChange = (id) => {
    statusChange(id);
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
    },
    {
      title: "Exchange Rate",
      dataIndex: "exchange_rate",
      key: "exchange_rate",
    },
    {
      title: "base Currency",
      dataIndex: "base_currency",
      key: "base_currency",
    },
    // { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dataSource = MasterCurrency?.map((value, i) => ({
    key: i, // Add a unique key for each row
    SNo: i + 1, // Changed to camelCase
    code: value?.currency_code,
    name: value?.currency_name,
    symbol: value?.currency_symbol,
    exchange_rate: value?.exchange_rate,
    // base_currency: value?.base_currency ? "YES" : "NO",

    base_currency: (
      <>
        <span
          id={`flexSwitchCheckChecked-${i}`}
          title="Click to change status"
          onClick={() => handleChange(value.id)}
          className={`cursor-pointer ${
            value.base_currency === true
              ? "badge badge-pill badge-status bg-success"
              : "badge badge-pill badge-status bg-danger"
          }  `}
        >
          {value.base_currency === true ? "YES" : "NO"}
        </span>
      </>
    ),

    // action: (
    //   <div className="dropdown table-action">
    //     <Link to="#" className="action-icon" data-bs-toggle="dropdown">
    //       <i className="fa fa-ellipsis-v"></i>
    //     </Link>
    //     <div className="dropdown-menu dropdown-menu-right">
    //       <div
    //         className=" cursor-pointer"
    //         onClick={() => {
    //           //  handleEditShow(value?.id);
    //           setMasterID(value?.id);
    //           setMasterName(value?.name);
    //         }}
    //       >
    //         <i className="ti ti-edit text-blue"></i> Edit
    //       </div>
    //     </div>
    //   </div>
    // ),
  }));

  useEffect(() => {
    if (!token) {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
    dispatch(getCurrency());
    dispatch(
      getMasterCurrency(
        token,
        user_id,
        queryParams.get("page") ?? 1,
        queryParams.get("search"),
      ),
    );
  }, []);

  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>
      <div>
        <h5 className="fw-semibold mb-3">Currency Master Form</h5>

        <div className="row">
          {/* currency_code */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">Currency Code</label>
            <select
              name="currency_code"
              className="form-select bg-light padding-pt-9"
              value={groupFormData.currency_code}
              onChange={handleCurrencyChange}
            >
              <option value="">Select Currency Code</option>
              {currencyData.map((item) => (
                <option key={item.id} value={item.currency}>
                  {item.currency}
                </option>
              ))}
            </select>
          </div>

          {/* currency_name */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">Currency Name</label>

            <select
              className="form-select bg-light padding-pt-9"
              value={groupFormData.currency_name}
              disabled
            >
              <option value="">
                {groupFormData.currency_name || "Currency Name"}
              </option>
            </select>
          </div>

          {/* currency_symbol */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">Currency Symbol</label>
            <select
              className="form-select bg-light padding-pt-9"
              value={groupFormData.currency_symbol}
              disabled
            >
              <option value="">
                {groupFormData.currency_symbol || "Currency Symbol"}
              </option>
            </select>
          </div>

          {/* exchange_rate*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Exchange Rate <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="exchange_rate"
              className="form-control bg-light"
              placeholder="Enter Exchange Rate"
              onChange={onValueChange}
              value={groupFormData.exchange_rate}
            />
          </div>

          {/* base_exchange_rate*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Base Exchange Rate <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="base_exchange_rate"
              className="form-control bg-light"
              placeholder="Enter Exchange Rate"
              onChange={onValueChange}
              value={groupFormData.base_exchange_rate}
            />
          </div>

          {/* rate_date*/}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">
              Rate Date<span className="text-danger">*</span>
            </label>
            <input
              type="date"
              name="rate_date"
              className="form-control bg-light"
              placeholder="Rate Date"
              onChange={onValueChange}
              value={groupFormData.rate_date}
            />
          </div>

          {/* rate_source */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">Rate Source</label>
            <select
              onChange={onValueChange}
              value={groupFormData.rate_source}
              name="rate_source"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Currency Symbol </option>
              <option value="Manual">Manual </option>
              <option value="API">API </option>
              <option value="Bank">Bank </option>
            </select>
          </div>

          {/* decimal_places */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">Decimal Places</label>
            <select
              onChange={onValueChange}
              value={groupFormData.decimal_places}
              name="decimal_places"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Decimal Places </option>
              <option value="1"> 1</option>
              <option value="2"> 2</option>
              <option value="3"> 3</option>
              <option value="4"> 4</option>
            </select>
          </div>

          {/* base_currency */}
          <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">Base Currency</label>
            <div className="d-flex align-items-center gap-2 mt-1">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked
                  name="base_currency"
                  checked={groupFormData.base_currency}
                  onChange={onValueChange}
                />
              </div>
              <span>{groupFormData.base_currency ? "Yes" : "No"}</span>
            </div>
          </div>

          {/* base_currency */}
          {/* <div className="col-12 col-sm-6 col-md-4 mb-4">
            <label className="form-label fw-medium">Auto Update</label>
            <div className="d-flex align-items-center gap-2 mt-1">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  defaultChecked
                  name="auto_update"
                  checked={groupFormData.auto_update}
                  onChange={onValueChange}
                />
              </div>
              <span>Disabled</span>
            </div>
          </div> */}
        </div>

        {/* ACTION BUTTONS */}
        <div className="d-flex gap-2 mt-3">
          <button
            onClick={() => submitGroupForm()}
            className="btn btn-primary px-4"
          >
            <i className="fas fa-save me-1"></i> Save
          </button>
        </div>

        <hr />

        {spinnerLoader ? (
          <>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "400px", width: "100%" }}
            >
              <BeatLoader />
            </div>
          </>
        ) : (
          <>
            <div className="table-responsive custom-table">
              <Table
                className="table datanew dataTable no-footer"
                dataSource={dataSource}
                columns={columns}
                pagination={false}
              />
            </div>

            <AccountPagination
              currentPage={MasterCurrencyCurrentPage}
              totalPages={MasterCurrencyTotalPage}
              onPageChange={(page) => {
                dispatch(getMasterCurrency(token, user_id, page));
              }}
            />
          </>
        )}
      </div>
    </>
  );
};

export default CurrencyCreateForm;
